import { jsx as _jsx } from "react/jsx-runtime";
//TODO: figure out typing for forwardRef
import React from 'react';
const SelectEmptyItem = React.forwardRef((_, ref) => (_jsx("div", { ref: (node) => {
        //@ts-ignore
        ref && ref(node);
    } }, void 0)));
export default SelectEmptyItem;
